export default __webpack_public_path__ + "static/media/avatar_koala3.99722c10.mp3";